import Postmate from '@regily/regily-postmate'
import { getDynamicSettings } from '../utils/browserStructure'
import transformData from '../utils/data-transfrom'
import partnerConfig from './partner.module.config'
import { setChildToProxyMode, getExtendedExistingConnection } from '../partners/appModeHelpers'

let registrationShadowHandshake, registrationShadow, shadowHolder

export function openRegistrationShadow ({ url: shadowRegistrationUrl, successCallback }) {
  if (registrationShadow) return registrationShadow

  if (!shadowHolder) {
    shadowHolder = document.createElement('div')
    shadowHolder.id = 'shadow-holder'

    // Hide shadow registration
    shadowHolder.style.position = 'absolute'
    shadowHolder.style.top = '10000px'

    document.body.appendChild(shadowHolder)
  }

  registrationShadowHandshake = registrationShadowHandshake || new Postmate({
    container: shadowHolder,
    url: shadowRegistrationUrl,
    handshakeRetryDelay: 250,
    handshakeRetryForever: true, // As we are in remote, we need to wait for partner to run the proxy indefinetly
    childOriginHandshake: '*' // Accepts '*' or the origin where the postmate handshake will be emitted
  }).then(connection => {
    // This is a replacement for  '?isAffiliate=true'
    setChildToProxyMode(connection, () => {
      registrationShadow = connection
      successCallback && successCallback()
    })
  }).catch((err) => {
    console.log('Error while creating shadow frame', err)
  })
}

export function isShadowRegistration () {
  return !!registrationShadow
}

export function shadowCallback (type, { data, dataDiff }) {
  const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1)
  const callbackProp = `regily${typeCapitalized}Callback`

  registrationShadow.call(`${callbackProp}Data`, { data, dataDiff })

  return new Promise((resolve, reject) => {
    registrationShadow.get(callbackProp).then((response) => {
      const errorData = response && response.error
      if (errorData) {
        const { name, title, message } = errorData
        const error = new Error(message)
        error.name = name
        error.title = title || message
        reject(error)
        return
      }

      resolve(response)
    })
  })
}

export async function runRegistrationShadowPostmate () {
  let sharedContainer = {} // to be used as a data container across the model

  const connectionModel = {
    data: {},
    dataDiff: {},
    dynamicSettings: getDynamicSettings(),
    locationURL: () => window.location.href,
    regilyUpdateCallbackData: ({ data, dataDiff }) => {
      sharedContainer.data = data
      sharedContainer.dataDiff = dataDiff
    },
    regilyUpdateCallback: () => new Promise((resolve) => {
      const isCallbackPresent = typeof window['regilyUpdateCallback'] === 'function'

      if (isCallbackPresent) {
        window['regilyUpdateCallback'](sharedContainer.data, sharedContainer.dataDiff).then(response => {
            resolve(response)
          }, error => {
            const errorResponse = {
              error: {}
            }
            errorResponse.error = Object.assign({}, error)
            errorResponse.error.message = error.message

            resolve(errorResponse)
        })
      }
    }),
    regilyDoneCallbackData: ({ data, dataDiff }) => {
      sharedContainer.data = data
      if (partnerConfig.settings.dataTransformSchema) {
        sharedContainer.data.mapped = transformData(sharedContainer.data, partnerConfig.settings.dataTransformSchema)
      }
    },
    regilyDoneCallback: () => new Promise((resolve) => {
      const isCallbackPresent = typeof window['regilyCallback'] === 'function' || typeof window['regilyDoneCallback'] === 'function'

      if (isCallbackPresent) {
        window['regilyDoneCallback'](sharedContainer.data).then(response => {
          resolve(response)
        }, error => {
          const errorResponse = {
            error: {}
          }
          errorResponse.error = Object.assign({}, error)
          errorResponse.error.message = error.message

          resolve(errorResponse)
        })
      } else {
        resolve(true)
      }
    })
  }

  // This is an attempt to connect to the parent holder iframe
  const childConnection = getExtendedExistingConnection(connectionModel) || await new Postmate.Model(connectionModel)
  return childConnection
}



// WEBPACK FOOTER //
// ./src/partners/remote.js